<template>
  <div></div>
</template>

<style scoped>
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntId: {
        type: Number,
        required: true
      },
      cpntAcao: {
        type: String,
        required: true,
        validator: function (val) {
          return ([ 'abrir', 'imprimir', 'xml' ].indexOf(val) !== -1)
        }
      },
      cpntOrigem: {
        type: String,
        required: true,
        default: function () {
          return 'df'
        }
      },
      cpntBuffer: {
        type: String,
        required: false,
        default: function () {
          return null
        }
      },
      cpntFileName: {
        type: String,
        required: false,
        default: function () {
          return (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        buffer: ''
      }
    },
    mounted: function () {
      this.notaAbrirOuImprimirIniciar()
    },
    methods: {
      notaAbrirOuImprimirIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.notaAbrirOuImprimirSetarStatusGeral('carregando')

        // VERIFICA SE FOI RECEBIDO ALGUM BUFFER
        switch (this.cpntBuffer) {
          case '':
          case null:
          case undefined:
            // MONTA OS VALORES DO LINK
            var queryGet = { clu: this.$store.state.token.clu }
 
            // VERIFICA O TIPO DO REGISTRO QUE DEVE ABRIR
            switch (this.cpntOrigem) {
              case 'compra_dist':
                queryGet.a_dem_compra_df_fornecedor = [ this.cpntId ]
                break

              case 'df':
                queryGet.a_id_df = [ this.cpntId ]
                break

              case 'dist':
                queryGet.a_id_df_dist = [ this.cpntId ]
                break
            }

            // VERIFICA SE É PARA BAIXAR XML
            queryGet = Object.assign(queryGet, (this.cpntAcao === 'xml' ? { pdf: '0', xml: '1'  } : { pdf: '1', xml: '0' }))

            if (this.cpntAcao === 'xml') {
              // FORMATA O LINK
              queryGet = '?t=' + encodeURIComponent(this.$store.state.FUN_CRIPTOGRAFIA('enc', queryGet, process.env.VUE_APP_C32_KEY))

              // INICIA O FORMULARIO
              var form = $('<form></form>').attr('id', this.cpntFileName + '--xml')
                                           .attr('method', 'post')
                                           .attr('action', (process.env.VUE_APP_DOC_FISCAL_ABR + queryGet))
                                           .attr('target', '_blank')

              // CRIA O INPUT PARA XML
              var field = $('<input></input>').attr('id', 'xml')
                                          .attr('type', 'hidden')
                                          .attr('name', 'xml')
                                          .attr('value', '1')
              // ADICIONA O INPUT NO FORMULARIO
              form.append(field)

              // // SETA O NOME DO ARQUIVO
              // field = $('<input></input>').attr('id', 'filename')
              //                             .attr('type', 'hidden')
              //                             .attr('name', 'filename')
              //                             .attr('value', this.cpntFileName)
              // ADICIONA O INPUT NO FORMULARIO
              form.append(field)

              // SALVA O FORMULARIO NO HTML
              $(document.body).append(form)

              // ENVIA O FORMULARIO PARA O URL INFORMADO
              form.submit()

              // CHAMA A FUNÇÃO PARA FINALIZAR A IMPRESSÃO
              this.notaAbrirOuImprimirFecharIframe(form)
            } else {
              // FORMATA O LINK RECEBIDO
              queryGet = encodeURI(this.$store.state.FUN_CRIPTOGRAFIA('enc', queryGet, process.env.VUE_APP_C32_KEY))

              // COMUNICA COM A API PARA BUSCAR O PDF
              this.$store.state.comunicaAPI('/df/conteudo/get/', 'GET', queryGet, (apiSuccess) => {
                if (apiSuccess.lot.length === 1 && apiSuccess.lot[0].code === '200') {
                  // VERIFICA SE EXISTE A CHAVE COM O PDF
                  if ([ '', null, undefined ].indexOf(apiSuccess.lot[0].ref.rDocPDFBase64) === -1) {
                    this.buffer = apiSuccess.lot[0].ref.rDocPDFBase64
                  } else if ([ '', null, undefined ].indexOf(apiSuccess.lot[0].ref.rDocPDFEventos) === -1) {
                    this.buffer = apiSuccess.lot[0].ref.rDocPDFEventos[0].rDocEvePDFBase64
                  }
  
                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()
  
                  // CHAMA A FUNÇÃO PARA FINALIZAR A ACAO
                  this.notaAbrirOuImprimirFinalizar()
                } else {
                  this.$store.state.msgWarn('API [500]: Erro cod. (1) ao capturar arquivo PDF solicitado.', 'danger')
                }
              }, this.notaAbrirOuImprimirSetarStatusGeral)
            }
            break

          default:
            // COPIA OS DADOS PARA VARIAVEL PDF
            this.buffer = this.cpntBuffer

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA FINALIZAR A ACAO
            this.notaAbrirOuImprimirFinalizar()
            break
        }
      },
      notaAbrirOuImprimirSetarStatusGeral: function (status) {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      notaAbrirOuImprimirFecharIframe: function (elemento) {
        setTimeout(() => {
          // LIMPA O VALOR DO CAMPO
          this.cpntFecharFormulario(true)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          if ([ '', null, undefined ].indexOf(elemento) === -1) {
            setTimeout(() => {
              // REMOVE O IFRAME QUE FOI ADICIONADO A TELA
              elemento.remove()
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }, 30000)
          }
        }, 1000)
      },
      notaAbrirOuImprimirFinalizar: function () {
        // PEGA O PDF EM B64
        var base64str = this.buffer

        // DECODIFICAR A SEQUÊNCIA BASE64, REMOVER ESPAÇO PARA COMPATIBILIDADE COM O IE
        // DESCRIPTOGRAFA O B64 PARA RESOLVER PROBLEMA DO IE
        var binary = atob(base64str.replace(/\s/g, ''))
        var len = binary.length
        var buffer = new ArrayBuffer(len)
        var view = new Uint8Array(buffer)
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i)
        }

        // CRIE O OBJETO BLOB COM O CONTENT-TYPE "APPLICATION/PDF"
        var blob = new Blob([ view ], { type: "application/pdf" })
        var url = window.URL.createObjectURL(blob)
        // url.attr("download", 'teste.pdf');

        // var a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // a.href = url;
        // a.download = 'teste'

        // console.log(a)

        switch (this.cpntAcao) {
          case 'abrir':
            // ABRE EM UMA NOVA ABA O BLOB
            window.open(url, '_blank')

            // CHAMA A FUNÇÃO PARA FINALIZAR A IMPRESSÃO
            this.notaAbrirOuImprimirFecharIframe()
            break

          case 'imprimir':
            if (navigator.userAgent.indexOf('Chrome/') !== -1) {
              // CRIA A TAG IFRAME
              var iframe = document.createElement('iframe')

              // SETA O ID DOCAMPO
              iframe.id = 'output_frame'

              // ADICIONA O DISPLAY NONE NO DOCUMENTO
              iframe.style = 'display: none;'

              // SETA O BLOB DO ARQUIVO
              iframe.src = url

              // MONTA A FUNÇÃO PARA IMPRIMIR O DOCUMENTO
              iframe.onload = () => {
                var el = null
                if (iframe.contentDocument) {
                  el = iframe.contentDocument
                }

                if (el !== null) {
                  // EXECUTA A FUNÇÃO PARA IMPRMIR O DOCUMENTO
                  el.execCommand("print", true, null)
  
                  // CHAMA A FUNÇÃO PARA FINALIZAR A IMPRESSÃO
                  this.notaAbrirOuImprimirFecharIframe(iframe)
                } else {
                  // APRESENTA A MESNAGEM PARA O CLIENTE
                  this.$store.state.msgWarn('API [500]: Erro cod. (6) ao enviar comando print.', 'danger')

                  // LIMPA O VALOR DO CAMPO
                  this.$store.commit('SET_APP_PRINT_DOC_DOCS', null)
                }
              }

              // SALVA O FORMULARIO NO HTML
              $(document.body).append(iframe)
            } else {
              var field = null

              var form = $('<form></form>')
                .attr('method', 'post')
                .attr('action', process.env.VUE_APP_DOC_FISCAL_PRT)
                .attr('target', 'form_output')

              field = $('<input></input>')
                .attr('id', 'buffer')
                .attr('type', 'hidden')
                .attr('name', 'buffer')
                .attr('value', this.buffer)
              form.append(field)

              field = $('<input></input>')
                .attr('id', 'filename')
                .attr('type', 'hidden')
                .attr('name', 'filename')
                .attr('value', (Math.floor(Math.random() * (9999 - 1000)) + 1000))
              form.append(field)

              // SALVA O FORMULARIO NO HTML
              $(document.body).append(form)

              setTimeout(() => {
                // ENVIA O FORMULARIO PARA O URL INFORMADO
                form.submit()

                // CHAMA A FUNÇÃO PARA FINALIZAR A IMPRESSÃO
                this.notaAbrirOuImprimirFecharIframe(form)
              }, 500)
            }
            break

          default:
            // APRESENTA A MESNAGEM PARA O CLIENTE
            this.$store.state.msgWarn('API [500]: Erro ao identificar o tipo da ação (' + this.cpntAcao + ') que deve ser realizada com o docs.', 'danger')

            // LIMPA O VALOR DO CAMPO
            // this.$store.commit('SET_APP_PRINT_DOC_DOCS', null)
            this.notaAbrirOuImprimirFecharIframe()
            break
        }
      }
    }
  }
</script>
